import device from './device';

export * from './colors';
export * from './styleProps';

export default device;
